export default __webpack_public_path__ + "static/media/closebutton.5cc943d2.png";